import { PAGE_CREATION_BLACK_LIST } from "app/modules/project-from-comparison/config";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const WEBSITE_ANALYSIS = "digitalsuite_website";

export const isWebsiteAnalysisPage = (): boolean => {
    const { parent = "", name = "" } = proNavigator.current();

    return parent.includes(WEBSITE_ANALYSIS) && !PAGE_CREATION_BLACK_LIST.includes(name);
};
